import { render, staticRenderFns } from "./OnboardingWizardModal.vue?vue&type=template&id=2908f2b6&scoped=true&"
import script from "./OnboardingWizardModal.vue?vue&type=script&lang=js&"
export * from "./OnboardingWizardModal.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingWizardModal.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./OnboardingWizardModal.vue?vue&type=style&index=1&id=2908f2b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2908f2b6",
  null
  
)

export default component.exports